import { TransactionItemDetailEditProvider } from '@/features/transaction_items/Detail/context/TransactionItemDetailEdit';
import { TransactionItemDetail } from '@/features/transaction_items/Detail/TransactionItemDetail';
import { FC, memo } from 'react';

const TransactionItemDetailPage: FC = memo(() => {
  return (
    <TransactionItemDetailEditProvider>
      <TransactionItemDetail />
    </TransactionItemDetailEditProvider>
  );
});

TransactionItemDetailPage.displayName = 'TransactionItemDetailPage';
export default TransactionItemDetailPage;
